module.exports = __webpack_public_path__ + "img/floor4.ef5019b1.jpg";